<rt-icons-container></rt-icons-container>

<div class="app-content">
  <div class="content-wrap" layout-full-width layout-full-height>
    <div *ngIf="loading" class="spinner-container">
      <rt-spinner></rt-spinner>
    </div>

    <rtc-detached-router-outlet></rtc-detached-router-outlet>
  </div>
</div>
